import { contextualizeLoggedInUser } from '../models';
var contextualizeActions = function contextualizeActions(params) {
  return params;
};
export var userLayers = [{
  id: 'User',
  type: 'user',
  name: 'user',
  contextualize: function contextualize(_ref) {
    var user = _ref.user;
    return contextualizeLoggedInUser(user);
  }
}, {
  event: true,
  id: 'Subscribe',
  type: 'subscribe',
  name: 'subscribe',
  contextualize: contextualizeActions
}, {
  event: true,
  id: 'Subscribe',
  type: 'unsubscribe',
  name: 'unsubscribe',
  contextualize: contextualizeActions
}, {
  event: true,
  id: 'Like',
  type: 'like',
  name: 'like',
  contextualize: contextualizeActions
}, {
  event: true,
  id: 'Like',
  type: 'unlike',
  name: 'unlike',
  contextualize: contextualizeActions
}, {
  id: 'UserCookie',
  type: 'cookieSupport',
  action: 'cookieSupport',
  event: true,
  contextualize: function contextualize(_ref2) {
    var support = _ref2.support;
    return {
      support: support
    };
  }
}];